
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"3.5 4.23 28.27 28.27"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.994 28.497v-.889a3.582 3.582 0 00-1.805-3.11l-3.565-2.045m-5.977 0l-3.565 2.045a3.583 3.583 0 00-1.806 3.11v.89m8.36-23.268C10.38 5.23 4.5 11.11 4.5 18.365c0 7.254 5.88 13.135 13.135 13.135S30.77 25.62 30.77 18.365m-13.135 5.373c-2.638 0-4.776-2.735-4.776-5.373v-2.388a4.777 4.777 0 019.553 0v2.388c0 2.638-2.14 5.373-4.777 5.373z","stroke":"#0A203D","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{staticClass:"p",attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M29.131 9.77h-1.847v1.848a.527.527 0 11-1.054 0V9.77h-1.848a.527.527 0 110-1.054h1.848V6.868a.527.527 0 111.054 0v1.848h1.848a.527.527 0 110 1.054zM26.758 4.5a4.743 4.743 0 100 9.487 4.743 4.743 0 000-9.487z","fill":"#0A203D"}})])
          )
        }
      }
    